import React, {useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import {LinkOnComponent} from 'app/components/links/link';
import TeamHistoryRow from 'app/components/team/teamHistoryRow';
import styled from 'styled-components';
import {COLORS, SIZES, LoadingIndicator, LOADING_MESSAGE, Typography} from '@fupa/fupa-uikit';
import {string} from 'prop-types';
import {Helmet} from 'react-helmet-async';
import {AdSlot} from 'app/components/ads/AdSlot';
import {fetchTeamHistory} from 'app/routes/team/TeamPageActions';
import {useParams} from 'react-router';
import {useFetchData, useRestoreData, useDataFetchFinished} from 'app/hooks/dataHooks';
import {TeamHistoryPageReducer} from 'app/routes/team/TeamPageReducer';

const SeasonHeader = styled.div`
  display: flex;
  padding: ${SIZES['12']} ${SIZES['16']};
  background-color: ${COLORS.white};
`;

const Season = styled(Typography)`
  flex: 1 20%;
`;

const League = styled(Typography)`
  flex: 1 70%;
`;

const Rank = styled(Typography)`
  flex: 1 10%;
`;

const TeamHistoryPage = ({defaultMetaDesc, dispatchRedux}) => {
  const {restoredData} = useRestoreData('TeamHistoryPage');
  const {teamSlug} = useParams();

  const initialState = restoredData ?? {
    isFetching: false,
    items: [],
  };

  const [state, dispatch] = useReducer(TeamHistoryPageReducer, initialState);

  const loadData = () => fetchTeamHistory(teamSlug, dispatchRedux)(dispatch, state);

  const {isFetching, items} = state;
  useFetchData(state, loadData, 'TeamHistoryPage');
  const loadingDataFinished = useDataFetchFinished(isFetching);

  const title = 'Chronik - ';
  const meta = [{name: 'description', content: `${title}${defaultMetaDesc}`}];

  const seasonRows = items.map(season => (
    <LinkOnComponent key={season.slug} enablehover={true.toString()} to={`/team/${season.slug}`}>
      <TeamHistoryRow season={season} />
    </LinkOnComponent>
  ));

  let adUnit = null;
  if (loadingDataFinished) {
    if (seasonRows.length > 0) {
      seasonRows.length > 4 ? seasonRows.splice(5, 0, <AdSlot key='Content_1' adUnit='Content_1' />) : null;
    }

    adUnit = !seasonRows.length || seasonRows.length <= 4 ? <AdSlot key='Content_1' adUnit='Content_1' /> : null;
  }

  const content = isFetching ? <LoadingIndicator message={LOADING_MESSAGE.loadingData} bgColor /> : seasonRows;

  return (
    <ContentAdDesktop superbannerOnly top='7.125rem'>
      <Helmet title={title} meta={meta} />
      <SeasonHeader>
        <Season variant='caption1'>Saison</Season>
        <League variant='caption1'>Liga</League>
        <Rank variant='caption1'>Platz</Rank>
      </SeasonHeader>
      {content}
      {adUnit}
    </ContentAdDesktop>
  );
};

TeamHistoryPage.propTypes = {
  defaultMetaDesc: string.isRequired,
};

export default TeamHistoryPage;
